"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAlertingTemporarilyDisabledForGivenFilter = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var last_1 = tslib_1.__importDefault(require("lodash/last"));
function isAlertingTemporarilyDisabledForGivenFilter(kpi, filters, userWorkspaceSettings) {
    var hasDateDataSet = !!kpi.dateDataSet;
    if (!hasDateDataSet) {
        // for KPI's not connected to a dateDataSet, the filter config is irrelevant -> alerts are never disabled
        return false;
    }
    var effectiveDateFilter = last_1.default(filters.filter(sdk_model_1.isDateFilter));
    if (!effectiveDateFilter || sdk_model_1.isAllTimeDateFilter(effectiveDateFilter)) {
        return false;
    }
    var isAfmExecutorEnabled = !!(userWorkspaceSettings === null || userWorkspaceSettings === void 0 ? void 0 : userWorkspaceSettings["kpi.alerting.useAfmExecutor"]);
    if (isAfmExecutorEnabled) {
        // AfmExecutor supports all filters except static ranges
        return sdk_model_1.isAbsoluteDateFilter(effectiveDateFilter);
    }
    else {
        // we only allow the alerts for backwards-compatible filters now
        // i.e. relative presets without exclude current period selected
        if (!sdk_model_1.isRelativeDateFilter(effectiveDateFilter)) {
            return true;
        }
        var _a = sdk_model_1.relativeDateFilterValues(effectiveDateFilter), from = _a.from, to = _a.to;
        var endsInPreviousPeriod = to === -1; // ends in previous period
        var isLongerThanOnePeriod = from !== to; // but is not only that period (e.g. last year)
        return endsInPreviousPeriod && isLongerThanOnePeriod;
    }
}
exports.isAlertingTemporarilyDisabledForGivenFilter = isAlertingTemporarilyDisabledForGivenFilter;
//# sourceMappingURL=filterUtils.js.map